import React, { useEffect, useState } from 'react'
import { useMutation } from 'react-query'
import { postBusinessNewImplementation } from '../../../Api'
import buildQuery from '../BusinessQueryBuild'
import useStore from '../BusinessStore/Store'
import ExpandedFilters from './ExpandedFilters/ExpandedFilters'
import Name from './Name/Name'
import Categories from './PrimaryCategories/PrimaryCategories'
import { CircularProgress } from '@material-ui/core'
import BaseAlert from '../../Snackbar/NewImplementations/BaseAlert/BaseAlert'
import styles from './styles.module.css'

export default function SearchFilters () {
  const {
    name,
    city,
    primaryCategories,
    address,
    state,
    postalCode,
    country,
    rawCategory,
    recordRecency,
    featureKeyword,
    description,
    requiredFields,
    reviews,
    menus,
    geoLocation,
    reviewsRangeQuery,
    firstRender,
    setFirstRender,
    page,
    setPage,
    setIsQueryLoading,
    isQueryLoading,
    setQueryStore,
    setDataResults,
    setDownloadQueryStore,
    reviewsByDate
  } = useStore()

  const [alert, setAlert] = useState({
    open: false,
    title: '',
    body: '',
    color: '#EF3688',
    actions: []
  })

  const [query, setQuery] = useState()

  const [searchFilterRequest] = useMutation(
    ({ page, query }) => postBusinessNewImplementation(page, query),
    {
      onMutate: () => {
        setIsQueryLoading(true)
      },
      onSuccess: data => {
        if (data?.data?.errors || data.status >= 400) {
          setQueryStore(query)
          const errMsg = data?.data?.errors?.[0] || 'Something went wrong'

          if (errMsg.includes('business:paginate')) {
            setAlert({
              open: true,
              title: 'Feature not enabled',
              body: 'You need to enable "business.paginate" on your account to use this feature. Contact our team to request that this feature be enabled.',
              color: '#000000',
              actions: [
                {
                  label: 'Ok',
                  onClick: () => setAlert(a => ({ ...a, open: false }))
                },
                {
                  label: 'Contact support',
                  onClick: () => {
                    window.location.href = 'mailto:support@datafiniti.co'
                    setAlert(a => ({ ...a, open: false }))
                  }
                }
              ]
            })
          } else if (errMsg === 'No results found for provided query.') {
            setAlert({
              open: true,
              title: 'No results found',
              body: 'Try broadening your filters to find matches.',
              color: '#000000',
              actions: [
                {
                  label: 'Ok',
                  onClick: () => setAlert(a => ({ ...a, open: false }))
                }
              ]
            })
          } else {
            setAlert({
              open: true,
              title: 'Search Error',
              body: errMsg,
              color: '#EF3688',
              actions: [
                {
                  label: 'Ok',
                  onClick: () => setAlert(a => ({ ...a, open: false }))
                }
              ]
            })
          }

          setIsQueryLoading(false)
          return
        }

        setQueryStore(query)
        setDataResults(data)
        setDownloadQueryStore({ query: '', id: '' })
      },
      onError: error => {
        setAlert({
          open: true,
          title: 'Error',
          body: error.message || 'An error occurred',
          color: '#EF3688',
          actions: [
            {
              label: 'Ok',
              onClick: () => setAlert(a => ({ ...a, open: false }))
            }
          ]
        })
      },
      onSettled: () => {
        setIsQueryLoading(false)
      }
    }
  )

  useEffect(
    () => {
      if (!firstRender) {
        const newQuery = buildQuery(
          name,
          city,
          primaryCategories,
          address,
          state,
          postalCode,
          country,
          rawCategory,
          recordRecency,
          featureKeyword,
          description,
          requiredFields,
          reviews,
          menus,
          geoLocation,
          reviewsRangeQuery,
          reviewsByDate
        )
        setQuery({ query: newQuery })
        setPage(1)
      } else {
        setFirstRender(false)
      }
    },
    /* eslint-disable-line react-hooks/exhaustive-deps */ [
      name,
      city,
      primaryCategories,
      address,
      state,
      postalCode,
      country,
      rawCategory,
      recordRecency,
      featureKeyword,
      description,
      requiredFields,
      reviews,
      menus,
      geoLocation,
      reviewsRangeQuery,
      reviewsByDate
    ]
  )

  useEffect(
    () => {
      if (!firstRender && query) {
        searchFilterRequest({ page, query })
      }
    },
    /* eslint-disable-line react-hooks/exhaustive-deps */ [
      query,
      page,
      searchFilterRequest
    ]
  )

  useEffect(() => {
    return () => setFirstRender(true)
  }, [setFirstRender])

  return (
    <div>
      <h1 className={styles.searchFilterBusiness}>Search filters</h1>
      <div style={{ display: 'flex', marginBottom: '50px' }}>
        <Name />
        <Categories />
        <ExpandedFilters />
        <div style={{ display: 'flex', alignItems: 'flex-end' }}>
          {isQueryLoading ? (
            <CircularProgress
              disableShrink
              size={25}
              style={{ color: '#065E88', marginBottom: '5px' }}
            />
          ) : null}
        </div>
      </div>

      <BaseAlert
        open={alert.open}
        title={alert.title}
        body={alert.body}
        color={alert.color}
        style={{ width: '320px' }}
        actions={alert.actions}
        onClose={() => setAlert(a => ({ ...a, open: false }))}
      />
    </div>
  )
}
